// extracted by mini-css-extract-plugin
export default {"formContainer":"AddAccountant_formContainer__7R0kE","formField":"AddAccountant_formField__7J7c7","btnsContainer":"AddAccountant_btnsContainer__q6Ieb"};